<template>
  <modal name="status" :scrollable="true" height="auto" @before-open="beforeOpen">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Status <span class="date-and-time">[{{dataAndTime}}]</span></h5>
        <button type="button" class="close" @click="$modal.hide('status')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="statusCode" v-if="statusCode && !timeoutError">
            Data is currently unavailable ({{statusCode}}). Check if the cube is online.
        </div>

        <div class="statusCode" v-if="timeoutError">
            Data is currently unavailable. If the cube is online and the situation persists, update the cube installer.
        </div>

        <div class="status-data" v-if="!statusCode && media">
          <div>
            <div class="static-dashboard el-progress-circle">
              <div class="inner-text" v-text="media"></div>
              <svg viewBox="0 0 100 100">
                <path
                  d="M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
                  stroke="#e5e9f2"
                  stroke-width="4.8"
                  fill="none"
                  class="el-progress-circle__track"
                  style="stroke-dasharray: 221.482px, 295.31px; stroke-dashoffset: -36.9137px;"
                />
                <path
                  d=" M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
                  stroke="#ea2800"
                  fill="none"
                  stroke-linecap="round"
                  stroke-width="0"
                  class="el-progress-circle__path"
                  style="stroke-dasharray: 0px, 295.31px; stroke-dashoffset: -36.9137px; transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;"
                />
              </svg>
            </div>
            media
          </div>

          <div>
            <div class="static-dashboard el-progress-circle">
              <div class="inner-text" v-text="pages"></div>
              <svg viewBox="0 0 100 100">
                <path
                  d="M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
                  :stroke="paperStatusColor"
                  stroke-width="4.8"
                  fill="none"
                  class="el-progress-circle__track"
                  style="stroke-dasharray: 221.482px, 295.31px; stroke-dashoffset: -36.9137px;"
                />
                <path
                  d=" M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
                  stroke="#ea2800"
                  fill="none"
                  stroke-linecap="round"
                  stroke-width="0"
                  class="el-progress-circle__path"
                  style="stroke-dasharray: 0px, 295.31px; stroke-dashoffset: -36.9137px; transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;"
                />
              </svg>
            </div>
            pages
          </div>
          <div v-if="lifecounter">
            <div class="static-dashboard el-progress-circle">
              <div class="inner-text" v-text="lifecounter"></div>
              <svg viewBox="0 0 100 100">
                <path
                  d="M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
                  :stroke="paperCounterColor"
                  stroke-width="4.8"
                  fill="none"
                  class="el-progress-circle__track"
                  style="stroke-dasharray: 221.482px, 295.31px; stroke-dashoffset: -36.9137px;"
                />
                <path
                  d=" M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
                  stroke="#ea2800"
                  fill="none"
                  stroke-linecap="round"
                  stroke-width="0"
                  class="el-progress-circle__path"
                  style="stroke-dasharray: 0px, 295.31px; stroke-dashoffset: -36.9137px; transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;"
                />
              </svg>
            </div>
            counter
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="$modal.hide('status')">OK</button>
      </div>
    </div>
  </modal>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
    name: 'StatusModal',
    data () {
        return {
            time: 0,
            duration: 5000,
            colors: [
                { color: '#ea2800', percentage: 15 },
                { color: '#f07100', percentage: 30 },
                { color: '#f9bd00', percentage: 40 },
                { color: '#f3e002', percentage: 55 },
                { color: '#deed00', percentage: 70 },
                { color: '#8ada00', percentage: 85 },
                { color: '#00da3e', percentage: 100 }
            ],
            paper: 24,
            activeCubeName: undefined,
            cubesData: { media: '', pages: '', lifecounter: '' },
            timeoutInterval: 4000,
            timeoutIntervalId: null,
            timeoutError: false
        };
    },
    computed: {
        ...mapGetters(['getCubesStatus']),
        pages () {
            if(this.getCubesStatus[this.activeCubeName] && this.getCubesStatus[this.activeCubeName].pages) {
                return this.getCubesStatus[this.activeCubeName].pages;
            }
            return '';
        },
        lifecounter () {
            if(this.getCubesStatus[this.activeCubeName] && this.getCubesStatus[this.activeCubeName].lifecounter) {
                return this.getCubesStatus[this.activeCubeName].lifecounter;
            }
            return false;
        },
        media () {
            if(this.getCubesStatus[this.activeCubeName] && this.getCubesStatus[this.activeCubeName].media) {
                return this.getCubesStatus[this.activeCubeName].media;
            }
            return '';
        },
        statusCode () {
            if(this.getCubesStatus[this.activeCubeName] && this.getCubesStatus[this.activeCubeName].err) {
                if(this.getCubesStatus[this.activeCubeName].err.statusCode) {
                    return this.getCubesStatus[this.activeCubeName].err.statusCode;
                } else {
                    return this.getCubesStatus[this.activeCubeName].err.name;
                }
            }
            return '';
        },
        paperStatusColor () {
            let limit = (this.media === '6x8') ? 50: 25;
            return this.pages < limit ? '#ea6800' : '#e5e9f2';
        },      
        paperCounterColor () {
            return this.lifecounter > 8000 ? '#ea6800' : '#e5e9f2';
        },
        dataAndTime () {
            if(this.getCubesStatus[this.activeCubeName] && this.getCubesStatus[this.activeCubeName].timestamp) {
                return new Date(this.getCubesStatus[this.activeCubeName].timestamp).toUTCString();
            }
            return '';
        }
    },
    methods: {
        showActionsModal () {
            this.$modal.hide('status');
        },
        checkResponse () {
            if(!this.statusCode && !this.media) {
                this.timeoutError = true;
            }
        },
        beforeOpen (event) {
            this.activeCubeName = event.params.cubename;
            this.getData();
            this.timeoutError = false;

            if(this.timeoutIntervalId !== null) {
                clearInterval(this.timeoutIntervalId);
            }
            this.timeoutIntervalId = setTimeout(() => {
                this.checkResponse();
            }, this.timeoutInterval);
        },
        beforeClose () {
            if(this.timeoutIntervalId !== null) {
                clearInterval(this.timeoutIntervalId);
            }
        },
        getData () {
            let cube = this.$parent.cube;
            this.emitWithKey('update-envs', {
                context: cube.context,
                data: {
                    media: true,
                    cubename: 'cubestatus:' + cube.name
                }
            });
        },
        emitWithKey (method, data) {
            data.data.key = '8FD71A527448';
            data.state = '';
            this.$socket.client.emit(method, data);
        }
    }
};
</script>

<style lang="scss" scoped>
.statusCode {
    text-align: center;
}
.status-data {
  display: flex;
  width: 100%;
  height: 200px;
  align-items: center;
  justify-content: space-evenly;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30%;
  }
}
.preloader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 500ms ease;
  background: #fff;
}
.preloader.active {
  opacity: 1;
  transition: opacity 1ms ease;
}
.screen {
  height: 126px;
}
.static-dashboard {
  position: relative;
  width: 126px;
  height: 126px;
}
.inner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 16px;
  transform: translateX(-50%) translateY(-50%);
}
.date-and-time{
    font-size: .8rem;
    color: #999
}
</style>
